import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class DepartmentService {

    constructor(private api: ApiService) { }

    list(): Observable<any> {
        return this.api.get('hr/department/list');
    }
}
